import { render } from "./PresentationSlideSix.vue?vue&type=template&id=427b2e30&scoped=true"
import script from "./PresentationSlideSix.vue?vue&type=script&lang=js"
export * from "./PresentationSlideSix.vue?vue&type=script&lang=js"

import "./PresentationSlideSix.vue?vue&type=style&index=0&id=427b2e30&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427b2e30"]])

export default __exports__